import { 
  DashboardOutlined, 
  AppstoreOutlined,
  LineChartOutlined,
  UserOutlined,
  TeamOutlined,
  GiftOutlined,
  FileExcelOutlined,
  ClockCircleOutlined ,
  SettingOutlined,
  UsergroupAddOutlined ,
  
} from '@ant-design/icons';
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from 'configs/AppConfig'




const appsNavTree = [
  {
  key: 'menus',
  path: `${APP_PREFIX_PATH}/h`,
  title: 'Menus',
  icon: AppstoreOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'dashboard-overview',
      path: `${APP_PREFIX_PATH}/dashboard`,
      title: 'Dashboard',
      icon: LineChartOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'vip',
      path: `${APP_PREFIX_PATH}/vip`,
      title: 'VIP',
      icon: UserOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'public',
      path: `${APP_PREFIX_PATH}/public`,
      title: 'Public',
      icon: UsergroupAddOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'timeslotes',
      path: `${APP_PREFIX_PATH}/timeslotes`,
      title: 'Timeslotes',
      icon: ClockCircleOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'settings',
      path: `${APP_PREFIX_PATH}/settings`,
      title: 'Settings',
      icon: SettingOutlined,
      breadcrumb: false,
      submenu: []
    },
    // {
    //   key: 'excel',
    //   path: `${APP_PREFIX_PATH}/excel`,
    //   title: 'Excel management',
    //   icon: FileExcelOutlined,
    //   breadcrumb: false,
    //   submenu: []
    // },
    // {
    //   key: 'media',
    //   path: `${APP_PREFIX_PATH}/media`,
    //   title: 'Media',
    //   icon: FileImageOutlined,
    //   breadcrumb: false,
    //   submenu: []
    // },
  
  ]
}]


const navigationConfig = [
  // ...dashBoardNavTree,
  ...appsNavTree,
  // ...componentsNavTree,

  // ...docsNavTree
]

export default navigationConfig;
